export default function SectionCard({ title, icon, subtitle, children }) {
  return (
    <div className="card">
      <div className="flex items-center gap-2 mb-4">
        {icon && <span className="text-lg">{icon}</span>}
        <h3 className="section-title mb-0">{title}</h3>
      </div>
      {subtitle && <p className="text-xs text-slate-400 -mt-3 mb-4">{subtitle}</p>}
      {children}
    </div>
  );
}
